import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, ExternalLink } from 'lucide-react';
import Section from '../components/Section';
import TeamMember from '../components/TeamMember';
import PageHero from '../components/PageHero';
import Button from '../components/Button';
import { SF_UI } from '../components/ui/tokens';

const HALL_OF_FAME_TITLES = [
  {
    name: 'Angel+ Elite Founder',
    blurb: 'Groundbreaking visionaries of the SportsFuture ecosystem.',
    href: 'https://openplaza.io/editions/0x9d039e54DaC256FAc325D893Bd38797F35570f2d',
  },
  {
    name: 'Angel+ Elite Pioneer',
    blurb: 'Frontiers of the SportsFuture ecosystem.',
    href: 'https://openplaza.io/editions/0x6aC6D5806C72Aff865dA3028C1f6538b30282309',
  },
  {
    name: 'Angel+ Elite OG',
    blurb: 'Historical loyalists of the SportsFuture ecosystem.',
    href: 'https://openplaza.io/editions/0x561aEC05595E5435345059916e5e883F109df68f',
  },
  {
    name: 'Angel+ Elite Guardian',
    blurb: 'Silent protectors of the SportsFuture ecosystem.',
    href: 'https://openplaza.io/editions/0xb31249FFD77507fF4C9226bF35a9348368ec6F0a',
  },
  {
    name: 'Angel+ Elite Supporter',
    blurb: 'Silent supporters of the SportsFuture ecosystem.',
    href: 'https://openplaza.io/editions/0x1b256E1Ac619e5475E8db8cAe0638CA7f3799510',
  },
] as const;

const AboutPage = () => {
  const teamMembers = [
    {
      role: "Project Lead",
      image: '/01.png',
      bio: 'Former professional athlete with 10+ years in sports management and blockchain technology.'
    },
    {
      role: "Technology Officer",
      image: '/02.png',
      bio: 'Blockchain expert with experience at major tech companies. Committed to building the future of decentralized sports.'
    },
    {
      role: (
        <>
          <img src="https://flagcdn.com/w20/be.png" alt="Belgium flag" className="inline-block mr-1 w-4 h-auto" />
          Project Angel
        </>
      ),
      image: '/03.png',
      bio: 'Sports Officer from Belgium.'
    },
    {
      role: (
        <>
          <img src="https://flagcdn.com/w20/cw.png" alt="Curacao flag" className="inline-block mr-1 w-4 h-auto" />
          Project Angel
        </>
      ),
      image: '/03.png',
      bio: 'Sports Officer from Curacao.'
    },
    {
      role: (
        <>
          <img src="https://flagcdn.com/w20/do.png" alt="Dominica Republic flag" className="inline-block mr-1 w-4 h-auto" />
          Project Angel
        </>
      ),
      image: '/03.png',
      bio: 'Sports Officer from Dominican Republic.'
    },
    {
      role: (
        <>
          <img src="https://flagcdn.com/w20/ie.png" alt="Ireland flag" className="inline-block mr-1 w-4 h-auto" />
          Project Angel
        </>
      ),
      image: '/03.png',
      bio: 'Sports Officer from Ireland.'
    },
    {
      role: (
        <>
          <img src="https://flagcdn.com/w20/nl.png" alt="Netherlands flag" className="inline-block mr-1 w-4 h-auto" />
          Project Angel
        </>
      ),
      image: '/03.png',
      bio: 'Sports Officer from Netherlands.'
    },
    {
      role: "Project Angel",
      image: '/03.png',
      bio: 'Fostering growth in sports communities.'
    },
    {
      role: (
        <>
          <img src="https://flagcdn.com/w20/pt.png" alt="Portugal flag" className="inline-block mr-1 w-4 h-auto" />
          Project Angel
        </>
      ),
      image: '/03.png',
      bio: 'Sports Officer from Portugal.'
    },
    {
      role: (
        <>
          <img src="https://flagcdn.com/w20/pt.png" alt="Portugal flag" className="inline-block mr-1 w-4 h-auto" />
          Project Angel
        </>
      ),
      image: '/03.png',
      bio: 'Sports Officer from Portugal.'
    },
    {
      role: (
        <>
          <img src="https://flagcdn.com/w20/gb-sct.png" alt="Scotland flag" className="inline-block mr-1 w-4 h-auto" />
          Project Angel
        </>
      ),
      image: '/03.png',
      bio: 'Sports Officer from Scotland.'
    },
    {
      role: (
        <>
          <img src="https://flagcdn.com/w20/za.png" alt="South Africa flag" className="inline-block mr-1 w-4 h-auto" />
          Project Angel
        </>
      ),
      image: '/03.png',
      bio: 'Sports Officer from South Africa.'
    },
    {
      role: (
        <>
          <img src="https://flagcdn.com/w20/za.png" alt="South Africa flag" className="inline-block mr-1 w-4 h-auto" />
          Project Angel
        </>
      ),
      image: '/03.png',
      bio: 'Sports Officer from South Africa.'
    },
    {
      role: (
        <>
          <img src="https://flagcdn.com/w20/za.png" alt="South Africa flag" className="inline-block mr-1 w-4 h-auto" />
          Project Angel
        </>
      ),
      image: '/03.png',
      bio: 'Sports Officer from South Africa.'
    },
    {
      role: (
        <>
          <img src="https://flagcdn.com/w20/za.png" alt="South Africa flag" className="inline-block mr-1 w-4 h-auto" />
          Project Angel
        </>
      ),
      image: '/03.png',
      bio: 'Sports Officer from South Africa.'
    },
    {
      role: (
        <>
          <img src="https://flagcdn.com/w20/za.png" alt="South Africa flag" className="inline-block mr-1 w-4 h-auto" />
          Project Angel
        </>
      ),
      image: '/03.png',
      bio: 'Sports Officer from South Africa.'
    },
    {
      role: (
        <>
          <img src="https://flagcdn.com/w20/za.png" alt="South Africa flag" className="inline-block mr-1 w-4 h-auto" />
          Project Angel
        </>
      ),
      image: '/03.png',
      bio: 'Sports Officer from South Africa.'
    },
    {
      role: (
        <>
          <img src="https://flagcdn.com/w20/gb.png" alt="United Kingdom flag" className="inline-block mr-1 w-4 h-auto" />
          Project Angel
        </>
      ),
      image: '/03.png',
      bio: 'Sports Officer from United Kingdom.'
    },
    {
      role: (
        <>
          <img src="https://flagcdn.com/w20/gb.png" alt="United Kingdom flag" className="inline-block mr-1 w-4 h-auto" />
          Project Angel
        </>
      ),
      image: '/03.png',
      bio: 'Sports Officer from United Kingdom.'
    },
    {
      role: (
        <>
          <img src="https://flagcdn.com/w20/gb.png" alt="United Kingdom flag" className="inline-block mr-1 w-4 h-auto" />
          Project Angel
        </>
      ),
      image: '/03.png',
      bio: 'Sports Officer from United Kingdom.'
    },
    {
      role: (
        <>
          <img src="https://flagcdn.com/w20/gb.png" alt="United Kingdom flag" className="inline-block mr-1 w-4 h-auto" />
          Project Angel
        </>
      ),
      image: '/03.png',
      bio: 'Sports Officer from United Kingdom.'
    },
    {
      role: (
        <>
          <img src="https://flagcdn.com/w20/zw.png" alt="Zimbabwe flag" className="inline-block mr-1 w-4 h-auto" />
          Project Angel
        </>
      ),
      image: '/03.png',
      bio: 'Sports Officer from Zimbabwe.'
    },
    {
      role: (
        <>
          <img src="https://flagcdn.com/w20/zw.png" alt="Zimbabwe flag" className="inline-block mr-1 w-4 h-auto" />
          Project Angel
        </>
      ),
      image: '/03.png',
      bio: 'Sports Officer from Zimbabwe.'
    },
    {
      role: "Project Angel",
      image: '/03.png',
      bio: 'Fostering growth in sports communities.'
    },
    {
      role: "Project Angel",
      image: '/03.png',
      bio: 'Fostering growth in sports communities.'
    }
  ];

  const projectAngelStartIndex = teamMembers.findIndex(member => 
    typeof member.role === 'object' && React.isValidElement(member.role)
  );

  return (
    <>
      <PageHero
        eyebrow="About"
        title="About SportsFuture"
        subtitle="Part of the Apertum ecosystem — a decentralized platform where innovation meets purpose, built for athletes worldwide."
      />
      <Section bgColor={SF_UI.sectionBand} className="pt-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className={`${SF_UI.surfaceCard} ${SF_UI.surfaceCardPad}`}
          >
            <p className="text-lg text-gray-700 mb-6">
              SportsFuture is part of the Apertum ecosystem, a thriving decentralized platform where innovation meets purpose. 
              It is a commitment to sustainability and long-term impact, built on the robust Apertum blockchain and integrated 
              with DAO1's decentralized governance.
            </p>
            <p className="text-lg text-gray-700 mb-6">
              Our mission is to ensure every athlete, regardless of circumstances, has the opportunity to thrive—both in 
              their sporting careers and beyond. We believe that talent should never be limited by financial constraints.
            </p>
            <p className="text-lg text-gray-700">
              Through our platform, we connect promising athletes with funding opportunities, community support, and 
              the resources they need to succeed.
            </p>
            <div className="mt-8">
              <Button
                as="a"
                href="https://www.youtube.com/playlist?list=PLHlf_ssJTHkcDSduPJ07kM0izAfrmX-wK"
                target="_blank"
                rel="noopener noreferrer"
                variant="secondary"
              >
                Watch Playlist
              </Button>
            </div>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="flex justify-center items-center"
          >
            <img 
              src="https://images.pexels.com/photos/258395/pexels-photo-258395.jpeg?auto=compress&cs=tinysrgb&h=650"
              alt="Athletes competing"
              className="rounded-2xl shadow-xl max-h-96 object-cover"
            />
          </motion.div>
        </div>
      </Section>

      <Section
        bgColor="bg-white"
        eyebrow="Hall of Fame"
        title="Angel+ Elite titles"
        subtitle="Exclusive on-chain titles in the SportsFuture ecosystem, created with developers and creators. Owning a Hall of Fame NFT is the right to hold that title on-chain."
        centered={true}
      >
        <div className={`max-w-3xl mx-auto ${SF_UI.surfaceCard} ${SF_UI.surfaceCardPad}`}>
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center">
              <Trophy className="h-8 w-8 text-white" />
            </div>
          </div>
          <p className="text-gray-700 text-center mb-8">
            SportsFuture Hall of Fame editions recognize people who help build the ecosystem.
            Each Angel+ Elite NFT is an exclusive on-chain position — Founder, Pioneer, OG,
            Guardian, or Supporter.
          </p>
          <ul className="space-y-3 mb-8">
            {HALL_OF_FAME_TITLES.map((title, index) => (
              <motion.li
                key={title.href}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.05 }}
              >
                <a
                  href={title.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start justify-between gap-4 rounded-xl border border-gray-100 bg-slate-50 px-4 py-3 transition hover:border-primary/30 hover:bg-primary-50"
                >
                  <div>
                    <div className="font-semibold text-gray-900">{title.name}</div>
                    <div className="text-sm text-gray-600">{title.blurb}</div>
                  </div>
                  <ExternalLink className="mt-1 h-4 w-4 flex-shrink-0 text-primary" />
                </a>
              </motion.li>
            ))}
          </ul>
          <div className="text-center">
            <Button
              as="a"
              href="https://explorer.apertum.io/token/0xf18931bC8C776dbAc07521e3Ab17391239075047"
              target="_blank"
              rel="noopener noreferrer"
              variant="outline"
            >
              View Hall of Fame on Explorer
            </Button>
          </div>
        </div>
      </Section>
      
      <Section bgColor="bg-primary-50" title="Our Ecosystem Partners" centered={true}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <motion.a
  href="https://apertum.io/"
  target="_blank"
  rel="noopener noreferrer"
  initial={{ opacity: 0, y: 20 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true }}
  transition={{ duration: 0.5 }}
  className="block bg-white p-6 rounded-2xl relative sf-surface-card sf-ui-system overflow-hidden group cursor-pointer
    /* Base shadow and effects for all devices */
    shadow-md 
    transition-all duration-300
    /* Mobile-specific always-on effects */
    sm:border-primary sm:border
    /* Desktop hover effects (preserved) */
    hover:shadow-xl hover:-translate-y-1 hover:bg-primary-50"
  whileHover={{ scale: 1.02 }}
  whileTap={{ scale: 0.98 }}
>
  {/* Flash effect overlay (hover on desktop only) */}
  <div className="absolute inset-0 bg-primary opacity-0 group-hover:opacity-5 transition-opacity duration-300"></div>
  
  {/* Border effect - visible on mobile, appears on hover for desktop */}
  <div className="absolute inset-0 border-2 border-primary sm:opacity-30 md:opacity-0 group-hover:opacity-100 rounded-lg transition-opacity duration-300"></div>
  
  {/* Explore text - always visible on mobile, appears on hover for desktop */}
  <div className="flex justify-center items-center mt-4 sm:opacity-100 md:opacity-0 group-hover:opacity-100 transition-opacity duration-300">
    <span className="text-primary font-medium">Explore Apertum</span>
    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
    </svg>
  </div>
  
  <div className="flex justify-center mb-4">
    <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center
      /* Subtle pulse animation only on mobile */
      sm:animate-[subtlePulse_2s_infinite]
      /* Scale effect on desktop hover */
      group-hover:scale-110 transition-transform duration-300">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    </div>
  </div>
  
  <h3 className="text-xl font-semibold text-center mb-2 group-hover:text-primary transition-colors duration-300">
    Apertum Blockchain
  </h3>
  
  <p className="text-gray-600 text-center group-hover:text-gray-700 transition-colors duration-300">
    A secure, scalable blockchain platform providing the technical foundation for SportsFuture's 
    decentralized applications and token ecosystem.
  </p>
</motion.a>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="bg-white p-6 rounded-lg shadow-md"
          >
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 bg-secondary rounded-full flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
            </div>
            <h3 className="text-xl font-semibold text-center mb-2">DAO1 Governance</h3>
            <p className="text-gray-600 text-center">
              A decentralized autonomous organization that enables community-driven decision making
              for the SportsFuture platform and its funding allocations.
            </p>
          </motion.div>
        </div>
      </Section>
      
      <Section
        title="Our Team"
        subtitle="Meet the passionate individuals behind SportsFuture"
        centered={true}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {teamMembers.map((member, index) => (
            <TeamMember
              key={index}
              name=""
              role={member.role}
              image={member.image}
              bio={member.bio}
              number={index >= projectAngelStartIndex ? index - projectAngelStartIndex + 1 : undefined}
              social={member.social}
              delay={index * 0.1}
            />
          ))}
        </div>
      </Section>
      
      <Section bgColor="bg-gray-900 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-6">Our Vision</h2>
          <p className="text-xl text-gray-300 mb-8">
            We envision a world where every dedicated athlete has the support needed to reach their full potential,
            regardless of background or economic circumstance. Through the power of decentralized technology and
            community engagement, we're building a more equitable future for sports.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="flex-1 flex items-center justify-center p-4"
            >
              <div className="text-center">
                <div className="text-4xl font-bold text-primary mb-2">2+</div>
                <p className="text-gray-400">Athletes Supported</p>
              </div>
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="flex-1 flex items-center justify-center p-4"
            >
              <div className="text-center">
                <div className="text-4xl font-bold text-primary mb-2">10+</div>
                <p className="text-gray-400">Countries Reached</p>
              </div>
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="flex-1 flex items-center justify-center p-4"
            >
              <div className="text-center">
                <div className="text-4xl font-bold text-primary mb-2">$0+</div>
                <p className="text-gray-400">Funding Distributed</p>
              </div>
            </motion.div>
          </div>
        </div>
      </Section>
    </>
  );
};

export default AboutPage;
